import { IconTypes } from '@eika/icon';
import { PendingTag } from '@eika/tag';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';
import {
    hasExistingProcessInCurrentBank,
    hasNotCompletedKYCForm,
    hasPendingKYCAdvisorReview,
    waitingForApproverParentConsent,
} from '@utils/child-status-utils';
import { useChildCardContext } from '../context';

const ProcessInProgress = () => {
    const { childCard } = useTranslation();

    return (
        <PendingTag
            aria-label={format(childCard.ariaLabel.processStatusFor, childCard.processInProgress)}
            data-testid="process-in-progress-tag"
            icon={IconTypes.TIMEGLASS_24}
        >
            {childCard.processInProgress}
        </PendingTag>
    );
};

const NotCompletedKYCForm = () => {
    const { childCard } = useTranslation();

    return (
        <PendingTag
            aria-label={format(childCard.ariaLabel.completeKYCFormFor, childCard.processInProgress)}
            data-testid="waiting-for-kyc-tag"
            icon={IconTypes.MER_24}
        >
            {childCard.waitingForKYC}
        </PendingTag>
    );
};

const PendingKYCAdvisorReview = () => {
    const { childCard } = useTranslation();

    return (
        <PendingTag data-testid="pending-kyc-advisor-review-tag" icon={IconTypes.STOPP_24}>
            {childCard.pendingKYCAdvisorReview}
        </PendingTag>
    );
};

export const ChildCardPendingTag = () => {
    const { childEligibility } = useChildCardContext();

    if (hasExistingProcessInCurrentBank(childEligibility)) {
        if (waitingForApproverParentConsent(childEligibility)) {
            return <ProcessInProgress />;
        }

        if (hasNotCompletedKYCForm(childEligibility)) {
            return <NotCompletedKYCForm />;
        }

        if (hasPendingKYCAdvisorReview(childEligibility)) {
            return <PendingKYCAdvisorReview />;
        }
    }

    return null;
};
